var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-location-7935",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.645,
    height: 35.559,
    viewBox: "0 0 35.645 35.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M36.388,26.447s.537,2,2.084,2.088c0,0-2.065.713-2.1,2.239,0,0-.406-2.14-2.038-2.216A2.442,2.442,0,0,0,36.388,26.447Z",
    transform: "translate(-31.278 -24.677)",
    fill: "#d6df58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M35.109,29.749a.237.237,0,0,1-.232-.192c0-.02-.393-1.958-1.816-2.025a.237.237,0,0,1-.024-.47,2.188,2.188,0,0,0,1.853-1.9.237.237,0,0,1,.464-.042c0,.018.514,1.833,1.87,1.914a.236.236,0,0,1,.063.459c-.019.007-1.91.679-1.941,2.021a.237.237,0,0,1-.217.23Zm-1.22-2.48a2.756,2.756,0,0,1,1.2,1.4A3.361,3.361,0,0,1,36.5,27.34a2.887,2.887,0,0,1-1.314-1.375A2.537,2.537,0,0,1,33.889,27.269Z",
    transform: "translate(-30.014 -23.415)",
    fill: "#3a312a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M17.9,43.428s.38,1.412,1.474,1.477c0,0-1.461.5-1.485,1.584,0,0-.288-1.513-1.441-1.568A1.727,1.727,0,0,0,17.9,43.428Z",
    transform: "translate(-16.212 -38.981)",
    fill: "#d6df58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M16.625,45.462a.237.237,0,0,1-.232-.192c0-.013-.268-1.331-1.22-1.376a.237.237,0,0,1-.024-.47A1.481,1.481,0,0,0,16.4,42.144a.236.236,0,0,1,.464-.042h0c0,.012.351,1.249,1.26,1.3a.236.236,0,0,1,.063.46c-.013,0-1.306.466-1.326,1.366a.237.237,0,0,1-.217.23Zm-.712-1.818a2.02,2.02,0,0,1,.7.832,2.471,2.471,0,0,1,.846-.784,2.111,2.111,0,0,1-.779-.824A1.882,1.882,0,0,1,15.913,43.644Z",
    transform: "translate(-14.948 -37.717)",
    fill: "#3a312a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M17.9,16.77s.38,1.412,1.474,1.477c0,0-1.461.5-1.485,1.584,0,0-.288-1.513-1.441-1.568A1.727,1.727,0,0,0,17.9,16.77Z",
    transform: "translate(-16.212 -16.526)",
    fill: "#d6df58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M16.625,18.8a.237.237,0,0,1-.232-.192c0-.013-.268-1.331-1.22-1.376a.237.237,0,0,1-.024-.47A1.481,1.481,0,0,0,16.4,15.486a.236.236,0,0,1,.464-.042h0c0,.012.351,1.249,1.26,1.3a.236.236,0,0,1,.063.46c-.013,0-1.305.465-1.326,1.365a.236.236,0,0,1-.217.23Zm-.712-1.817a2.02,2.02,0,0,1,.7.832,2.471,2.471,0,0,1,.846-.784,2.111,2.111,0,0,1-.779-.824A1.883,1.883,0,0,1,15.913,16.986Z",
    transform: "translate(-14.948 -15.262)",
    fill: "#3a312a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 17.538,
    cy: 7.123,
    rx: 17.538,
    ry: 7.123,
    transform: "translate(0.332 21.076)",
    fill: "#8ac5dc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M33.327,162.13a34.291,34.291,0,0,1-12.49-2.1c-3.408-1.384-5.284-3.251-5.284-5.256s1.877-3.872,5.284-5.256a34.294,34.294,0,0,1,12.49-2.1,34.289,34.289,0,0,1,12.49,2.1c3.408,1.384,5.284,3.251,5.284,5.256s-1.877,3.872-5.284,5.256A34.292,34.292,0,0,1,33.327,162.13Zm0-14.247a33.817,33.817,0,0,0-12.312,2.069c-3.217,1.307-4.989,3.018-4.989,4.818s1.772,3.511,4.989,4.818a33.816,33.816,0,0,0,12.312,2.069,33.815,33.815,0,0,0,12.312-2.069c3.217-1.307,4.99-3.018,4.99-4.818s-1.772-3.511-4.99-4.818A33.816,33.816,0,0,0,33.327,147.883Z",
    transform: "translate(-15.457 -126.57)",
    fill: "#3a312a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M81.518,178.32c4.491-.191,7.992-1.733,7.992-3.608,0-2-4-3.628-8.931-3.628s-8.931,1.624-8.931,3.628c0,1.861,3.452,3.394,7.9,3.6Z",
    transform: "translate(-62.709 -146.513)",
    fill: "#87796f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M80.256,177.292a.236.236,0,0,1-.01-.473c4.355-.185,7.766-1.666,7.766-3.371,0-1.838-3.982-3.391-8.7-3.391s-8.7,1.553-8.7,3.391c0,1.686,3.37,3.165,7.672,3.366a.236.236,0,1,1-.022.472c-4.706-.22-8.122-1.835-8.122-3.839,0-2.167,4.027-3.864,9.168-3.864s9.168,1.7,9.168,3.864c0,1.992-3.533,3.645-8.219,3.844Z",
    transform: "translate(-61.446 -145.249)",
    fill: "#3a312a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M68.3,36.6c2.088,3.39,4.391,6.5,5.407,7.84a.667.667,0,0,0,1.063,0c2.077-2.734,9.53-12.879,9.53-17.662a10.061,10.061,0,0,0-20.122,0c0,2.046,1.364,5.074,3.088,8.082Z",
    transform: "translate(-56.419 -16.483)",
    fill: "#ef6d7a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M72.978,43.678a.9.9,0,0,1-.719-.357c-.922-1.214-3.3-4.409-5.42-7.859a.236.236,0,1,1,.4-.248c2.113,3.432,4.476,6.613,5.394,7.821a.431.431,0,0,0,.686,0c.948-1.248,3.385-4.531,5.53-8.043C81.473,30.7,82.8,27.511,82.8,25.516a9.825,9.825,0,1,0-19.649,0c0,1.744,1.028,4.424,3.057,7.965a.237.237,0,0,1-.411.235c-2.07-3.613-3.119-6.372-3.119-8.2a10.3,10.3,0,1,1,20.6,0c0,4.821-7.331,14.847-9.578,17.8A.9.9,0,0,1,72.978,43.678Z",
    transform: "translate(-55.155 -15.219)",
    fill: "#3a312a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M119.576,18.22a9.641,9.641,0,0,0-1.576.128,9.839,9.839,0,0,1,8.248,9.7c0,1.994-1.329,5.183-3.952,9.476-1.49,2.44-3.121,4.77-4.3,6.383.517.708.944,1.279,1.233,1.66a.434.434,0,0,0,.687,0c.947-1.249,3.385-4.532,5.529-8.043,2.623-4.293,3.952-7.482,3.952-9.476A9.836,9.836,0,0,0,119.576,18.22Z",
    transform: "translate(-101.754 -17.747)",
    fill: "#d24e5c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 4.451,
    cy: 4.451,
    r: 4.451,
    transform: "translate(12.796 14.089) rotate(-82.027)",
    fill: "#fae6ca"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M102.953,60.18a4.688,4.688,0,1,1,4.688-4.688A4.693,4.693,0,0,1,102.953,60.18Zm0-8.9a4.215,4.215,0,1,0,4.215,4.215A4.219,4.219,0,0,0,102.953,51.278Z",
    transform: "translate(-85.13 -45.195)",
    fill: "#3a312a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocationIcon);
export default __webpack_public_path__ + "static/media/map_locationIcon.9472119f132f3623e109a33bbfc3e2f3.svg";
export { ForwardRef as ReactComponent };